import React, { useCallback, useState } from "react";
import { Box, Button, Typography, List, ListItem, ListItemText, Alert } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { TypographyTitle, TypographyBold } from '../style/typography';
import { RequestButton } from '../style/button'
import { uploadFormData } from "../func/api";


const UploadCSVFileButton = ({ file, setFile, setFileName, setError, setEarthquakeUUID, setUploadComplete, setSelectCSV, setLoading, earthquake_uuid }) => {

  const [uploadMessage, setUploadMessage] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");

  const handleUpload = async () => {
    setLoading(true);
    try {
      if (!file) {
        setError("アップロードするファイルを選択してください。");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("earthquake_uuid", earthquake_uuid);

      const response = await uploadFormData("api/upload_csv", formData);
        setUploadMessage("ファイルをアップロードしました！");
        setAlertSeverity("success");
        setAlertOpen(true);
        setFile(null);
        setFileName("");
        setSelectCSV(true)
        setEarthquakeUUID(response.earthquake_uuid);
        setUploadComplete(true)
    } catch (err) {
      setError("エラーが発生しました。もう一度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <RequestButton startIcon={<FileUploadOutlinedIcon />}
        variant="contained"
        onClick={handleUpload}
        disabled={!file}
      >
        アップロード
      </RequestButton>

      {uploadMessage && (
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={() => setAlertOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }} // 右上に表示
        >
          <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
            {uploadMessage}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default UploadCSVFileButton;
